import { render, staticRenderFns } from "./im-history-panel-forward.vue?vue&type=template&id=2eb642f9"
import script from "./im-history-panel-forward.vue?vue&type=script&lang=js"
export * from "./im-history-panel-forward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb642f9')) {
      api.createRecord('2eb642f9', component.options)
    } else {
      api.reload('2eb642f9', component.options)
    }
    module.hot.accept("./im-history-panel-forward.vue?vue&type=template&id=2eb642f9", function () {
      api.rerender('2eb642f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-history-panel-forward.vue"
export default component.exports